import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class PurchaseorderService {

  constructor(private httpClientService: HttpClientService) { }

  public getDepartment(data: any) {
    return this.httpClientService.post(CONFIG.PURCHASEORDER.GETDEPARTMENT, data)
  }

  public getDepartmentById(id: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GETDEPARTMENT_ID}?id=${id}`);
  }

  public createPurchaseOrder(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPURCHASEORDER}`, data);
  }

  public getPurchaseOrder(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDER}`, data)
  }

  public getPurchaseOrdersbyReady(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDERBYREADY}`, data)
  }

  public getPurchaseOrderById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDER_BYID}?${queryParam}`);
  }
  public updatePurchaseOrder(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PURCHASEORDER}`, data);
  }
  public deletePurchaseOrder(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PURCHASEORDER}`, data);
  }
  public createPurchaseOrderLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPURCHASEORDER_LINEITEM}`, data);
  }

  public getPurchaseOrderLineitemById(data: string) {
    let queryParam = `id=${encodeURIComponent(data)}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDER_BYID_LINEITEM}?${queryParam}`);
  }

  public updatePurchaseOrderLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PURCHASEORDER_LINEITEM}`, data);
  }

  public deletePurchaseOrderLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PURCHASEORDER_LINEITEM}`, data);
  }
  public getAutogeneratedPoNo() {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOGENERATE_PONUMBER}`);
  }

  public getAutogeneratedPoNumber(prefix: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOGENERATE_PONUMBER}?prefix=${prefix}`);
  }

  public checkPurchaseOrderNumber(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.CHECK_PURCHASEORDER_NO}?purchaseOrderNumber=${data}`);
  }

  // Manufacturing Orders EndPoints ..............................................

  public createManufacturingOrders(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEMO}`, data);
  }

  public createManufacturingOrdersLineItems(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEMOLINEITEMS}`, data);
  }

  public getALLMO(value: string, data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GETALLMO}`, data);
  }

  public updateManufacturingOrders(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_MANUFACTURING_ORDERS}`, data);
  }

  public getManufacturingOrdersById(id: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_MANUFACTURING_ORDERS_BYID}?id=${id}`);
  }

  public deleteMO(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETEMO}`, data);
  }

  public getManufacturingOrdersLineItems(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_MANUFACTURING_ORDERS_LINE_ITEMS}?id=${data}`);
  }

  public autoSearchPO(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOSEARCHPO}?searchText=${seachkey}`);
  }

  public autoSearchReturnPO(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDERRETURN.AUTOSEARCHRETURNPO}?searchText=${seachkey}`);
  }

  // public deleteMOLineItems(data :any){
  //   return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETEMOLINEITEM}`, data);
  // }

  // Project Manufacturing Orders EndPoints ..............................................

  public getALLPMO(value: string, data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GETALLPMO}`, data);
  }

  public createProjectManufacturingOrders(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPMO}`, data);
  }

  public createMBOMforsparsh(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPMOFORSPARSH}`, data);
  }

  public createManufacturingBOM(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEMBOM}`, data);
  }

  public createManufacturingBOMLine(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEMBOMLINE}`, data);
  }

  public getProjectManufacturingOrdersById(id: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PROJECT_MANUFACTURING_ORDERS_BYID}?id=${id}`);
  }

  public getManufacturingBOMById(id: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GETMBOM}?id=${id}`);
  }

  public updateProjectManufacturingOrders(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PROJECT_MANUFACTURING_ORDERS}`, data);
  }

  public deletePMO(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETEPMO}`, data);
  }

  public getManufacturingBOMlineById(id: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GETMBOMLINE}?id=${id}`);
  }

  public autogenerateManufacturingBatchNumber() {
    return this.httpClientService.get(CONFIG.PURCHASEORDER.AUTOGENERATE_MANUFACTURINGBATCH_NUMBER);
  }
  // public deleteMOLineItems(data :any){
  //   return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETEMOLINEITEM}`, data);
  // }

  public checkMONumber(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.CHECK_MANUFACTURINGORDER_NUMBER}?MONumber=${data}`);
  }

  public autosearchFinishGood(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOSEARCHFINISHGOODS}search?searchText=${seachkey}`);
  }

  public updatePOStatus(id: number, status: string, comment: string | null = null) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PURCHASEORDER_STATUS}?id=${id}&status=${status}&POComment=${comment}`);
  }

  public updatePOStatusForPoAdmin(id: number, status: string, comment: string | null = null) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PURCHASEORDER_STATUS_FOR_POADMIN}?id=${id}&status=${status}&POComment=${comment}`);
  }
  public updatePBOMLineItem(data: any) {
    return this.httpClientService.post(CONFIG.PURCHASEORDER.UPDATEPBOMLINEITEM, data);
  }

  //PO Receipt

  public getPOReceiptHeader(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PO_RECEIPT_HEADER}`, data)
  }

  public getPOReceiptForReturnPO(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PO_RECEIPT_RETURNPO}`, data)
  }

  public getPOReceiptLineitem(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PO_RECEIPT_LINEITEM_BYPONUMBER}?id=${data}`);
  }

  public getConsumedPOLineDiscount(purchaseOrderNumber: string, excludePoReceiptNumber?: string | null) {
    let q = `purchaseOrderNumber=${encodeURIComponent(purchaseOrderNumber)}`;
    const excl = excludePoReceiptNumber?.toString()?.trim();
    if (excl) {
      q += `&excludePoReceiptNumber=${encodeURIComponent(excl)}`;
    }
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_CONSUMED_PO_LINE_DISCOUNT}?${q}`);
  }

  public getPOReceiptHeaderById(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PO_RECEIPT_HEADER_BYID}?id=${data}`);
  }

  public getPOReceiptHeaderByReceiptNumber(poReceiptNumber: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PO_RECEIPT_HEADER_BY_RECEIPT_NUMBER}?id=${encodeURIComponent(poReceiptNumber)}` );
  }

  public createPOReceiptHeader(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATE_PO_RECEIPT_HEADER}`, data);
  }

  public createPOReceiptHeaderandLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATE_PO_RECEIPT_HEADER_AND_LINE_ITEM}`, data);
  }

  public updatePOReceiptHeader(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PO_RECEIPT_HEADER}`, data);
  }


  public createPOReceiptLineitem(data: any, status: string = "Save") {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATE_PO_RECEIPT_LINEITEM}?status=${status}`, data);
  }

  public updatePOReceiptLineitem(data: any, status: string = "Save") {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PO_RECEIPT_LINEITEM}?status=${status}`, data);
  }

  public deletePOReceiptLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PO_RECEIPT_LINEITEM}`, data);
  }

  public deletePOReceiptHeader(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PO_RECEIPTHEADER}`, data);
  }

  public getAutogenReceiptNo() {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOGENERATE_RECEIPTNUMBER}`);
  }

  public searchPOReceipt(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.SEARCH_PO_RECEIPT_HEADER}/search?searchText=${seachkey}`);
  }

  public getnextPoReceiptNumber() {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_NEXTPONUMBER}`)
  }

  public searchPOReceiptReturnPO(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.SEARCH_PO_RECEIPT_RETURNPO}?searchText=${seachkey}`);
  }

  public getLastCost(productId: any, warehouseId: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_LAST_COST}?productId=${productId}&warehouseId=${warehouseId}`);
  }

  public glPostGrn(poReceiptHeaderId: number, body: { createdBy: string } = { createdBy: '' }) {
    return this.httpClientService.post(`${CONFIG.INVENTORY.GL_POST_GRN}/${poReceiptHeaderId}`, body);
  }

  public getGlEntriesForGrn(poReceiptHeaderId: number) {
    return this.httpClientService.get(`${CONFIG.INVENTORY.GL_ENTRIES_GRN}/${poReceiptHeaderId}`);
  }

  // Store Consumption api's


  public checkSCNumber(data: any) {
    return this.httpClientService.get(`${CONFIG.STORECONSUMPTION.CHECK_STORECONSUMPTION_NUMBER}?MONumber=${data}`);
  }

  public getAllStoreConsumption(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.GET_ALLSTORECONSUMPTION}`, data)
  }

  public getStoreConsumptionById(data: any) {
    return this.httpClientService.get(`${CONFIG.STORECONSUMPTION.GET_ALLSTORECONSUMPTIONBYID}?id=${data}`);
  }

  public getStoreConsumptionByPmoId(data: any) {
    return this.httpClientService.get(`${CONFIG.STORECONSUMPTION.GET_ALLSTORECONSUMPTIONBYPMOID}?id=${data}`);
  }

  public CreateStoreConsumption(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.CREATE_STORECONSUMPTION}`, data);
  }

  public autogenerateSCNumber() {
    return this.httpClientService.get(CONFIG.STORECONSUMPTION.AUTOGENERATE_SERIALNUMBER);
  }

  public updateStoreCnsumption(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.UPDATE_STORECONSUMPTION}`, data);
  }

  public deleteStoreConsumption(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.DELETE_STORECONSUMPTION}`, data);
  }

  public SearchStoreConsumption(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.STORECONSUMPTION.SEARCHSP}?searchText=${seachkey}`);
  }

  // store comsuption line item data

  public CreateStoreConsumptionLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.CREATE_STORECONSUMPTIONLINEITEM}`, data);
  }

  public getStoreConsumptionlineitemByScId(data: any) {
    return this.httpClientService.get(`${CONFIG.STORECONSUMPTION.GET_ALLSTORECONSUMPTIONLINEITEMBYSCID}?id=${data}`);
  }

  public updateStoreConsumptionLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.UPDATE_STORECONSUMPTIONLINEITEM}`, data);
  }

  public autogenerateSCLNumber() {
    return this.httpClientService.get(CONFIG.STORECONSUMPTION.AUTOGENERATE_SERIALNUMBERSCL);
  }

  public deleteStoreConsumptionLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.STORECONSUMPTION.DELETE_STORECONSUMPTIONSCL}`, data);
  }

  // Purchase Order Return

  public createPOReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.CREATE_PO_RETURN}`, data);
  }

  public getPOReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.GET_PO_RETURN}`, data)
  }

  public updatePurchaseOrderReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.UPDATE_PURCHASEORDER_RETURN}`, data);
  }

  public getPurchaseOrderRetunById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDERRETURN.GET_PURCHASEORDERRETURN_BYID}?${queryParam}`);
  }

  public deletePOReturn(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.DELETE_PURCHASEORDER_RETURN}`, data);
  }

  public createPOReturnLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.CREATE_PO_RETURN_LINEITEM}`, data);
  }

  public getPOLineitemById(data: string) {
    let queryParam = `id=${encodeURIComponent(data)}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDERRETURN.GET_PO_RETURN_LINEITEM_BYID}?${queryParam}`);
  }

  public updatePOReturnLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.UPDATE_PURCHASEORDER_RETURN_LINEITEM}`, data);
  }

  public deletePOReturnLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDERRETURN.DELETE_PURCHASEORDER_RETURN_LINEITEM}`, data);
  }

  //Product Requsition
  public createProductRequisition(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPRODUCTREQUISITION}`, data);
  }

  public getProductRequisition(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PRODUCTREQUISITION}`, data)
  }

  // public getProductRequisitionbyReady(data: any) {
  //   return this.httpClientService.post(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDERBYREADY}`, data)
  // }

  public getProductRequisitionById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PRODUCTREQUISITIONBYID}?${queryParam}`);
  }
  public updateProductRequisition(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PRODUCTREQUISITION}`, data);
  }
  public deleteProductRequisition(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PRODUCTREQUISITION}`, data);
  }
  public autoSearchProductRequisition(seachkey: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.SEARCH_PRODUCTREQUISITION}?searchText=${seachkey}`);
  }
  public checkProductRequisitionNumber(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.CHECK_PRODUCTREQUISITION_NO}?productRequisitionNumber=${data}`);
  }
  public autogenerateProductRequisitionNumber() {
    return this.httpClientService.get(CONFIG.PURCHASEORDER.AUTOGENERATE_PRODUCTREQUISITIONNUMBER);
  }
  public updatePRStatus(id: number, status: string, comment: string | null = null) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PRODUCTREQUISITION_STATUS}?id=${id}&status=${status}&PRComment=${comment}`);
  }
  public isPOCreated(data: any) {
    let queryParam = `productRequisitionId=${data}`;
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PURCHASEORDERBYID}?${queryParam}`);
  }

  //Product Requsition LineItem
  public createProductRequisitionLineItem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.CREATEPRODUCTREQUISITION_LINEITEM}`, data);
  }
  //  public getProductRequisitionLineitemById(data: any) {
  //     let queryParam = `id=${encodeURIComponent(data)}`;
  //     return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PRODUCTREQUISITION_BYID_LINEITEM}?${queryParam}`);
  //   }
  public getProductRequisitionLineitemById(data: any) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GET_PRODUCTREQUISITION_BYID_LINEITEM}?id=${data}`);
  }

  public updateProductRequisitionLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.UPDATE_PRODUCTREQUISITION_LINEITEM}`, data);
  }

  public deleteProductRequisitionLineitem(data: any) {
    return this.httpClientService.post(`${CONFIG.PURCHASEORDER.DELETE_PRODUCTREQUISITION_LINEITEM}`, data);
  }
  // public getAutogeneratedPoNo(){
  //   return this.httpClientService.get(`${CONFIG.PURCHASEORDER.AUTOGENERATE_PONUMBER}`);
  // }

  // public checkProductRequisitionNumber(data: any) {
  //   return this.httpClientService.get(`${CONFIG.PURCHASEORDER.CHECK_PURCHASEORDER_NO}?purchaseOrderNumber=${data}`);
  // }
  public getPurchaseOrderByPONumber(PurchaseOrderNumber: string) {
    return this.httpClientService.get(`${CONFIG.PURCHASEORDER.GETTPONUMBERBYID}?poNumber=${PurchaseOrderNumber}`);
  }
  public getTaskByCode(TaskCode: string) {
    return this.httpClientService.get(`${CONFIG.CRM.GETTASKBYCODE}?TaskCode=${TaskCode}`);
  }
}
